import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { Alert, AlertDescription } from './ui/alert';
import { Button } from './ui/button';
import { Clock, Sparkles } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TrialBanner = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [trialInfo, setTrialInfo] = useState(null);

  useEffect(() => {
    fetchTrialStatus();
  }, []);

  const fetchTrialStatus = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${API}/auth/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.subscription_status === 'trial' && response.data.days_remaining !== undefined) {
        setTrialInfo(response.data);
      }
    } catch (error) {
      console.error('Error fetching trial status:', error);
    }
  };

  if (!trialInfo || trialInfo.days_remaining > 10) {
    return null;
  }

  const isUrgent = trialInfo.days_remaining <= 5;

  const getTrialMessage = () => {
    if (trialInfo.days_remaining === 0) {
      return t('trialBanner.trialEndsToday');
    } else if (trialInfo.days_remaining === 1) {
      return t('trialBanner.trialEndsIn', { days: 1 });
    } else {
      return t('trialBanner.trialEndsInPlural', { days: trialInfo.days_remaining });
    }
  };

  return (
    <Alert 
      className={`mb-6 ${isUrgent ? 'border-destructive/50 bg-destructive/5' : 'border-accent/50 bg-accent/5'}`}
      data-testid="trial-banner"
    >
      <div className="flex items-start gap-3">
        {isUrgent ? (
          <Clock className="w-5 h-5 text-destructive mt-0.5" />
        ) : (
          <Sparkles className="w-5 h-5 text-accent mt-0.5" />
        )}
        <div className="flex-1">
          <AlertDescription className="text-sm">
            <span className="font-semibold">{getTrialMessage()}</span>
            <span className="ml-2">{t('trialBanner.subscribeNow')}</span>
          </AlertDescription>
        </div>
        <Button 
          onClick={() => navigate('/subscription')}
          size="sm"
          className={isUrgent ? 'bg-destructive text-destructive-foreground hover:bg-destructive/90' : 'bg-accent text-accent-foreground hover:bg-accent/90'}
          data-testid="trial-subscribe-button"
        >
          {t('trialBanner.subscribeButton')}
        </Button>
      </div>
    </Alert>
  );
};

export default TrialBanner;
